"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnusedSideZone = exports.OneSidedGradient = exports.Zone = exports.createLinearScale = exports.getAbsoluteToleranceDirection = exports.getToleranceDirection = void 0;
/*
 * © 2026 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var toleranceScale_1 = require("./toleranceScale");
Object.defineProperty(exports, "getToleranceDirection", { enumerable: true, get: function () { return toleranceScale_1.getToleranceDirection; } });
Object.defineProperty(exports, "getAbsoluteToleranceDirection", { enumerable: true, get: function () { return toleranceScale_1.getAbsoluteToleranceDirection; } });
Object.defineProperty(exports, "createLinearScale", { enumerable: true, get: function () { return toleranceScale_1.createLinearScale; } });
var ToleranceZones_1 = require("./ToleranceZones");
Object.defineProperty(exports, "Zone", { enumerable: true, get: function () { return ToleranceZones_1.Zone; } });
Object.defineProperty(exports, "OneSidedGradient", { enumerable: true, get: function () { return ToleranceZones_1.OneSidedGradient; } });
Object.defineProperty(exports, "UnusedSideZone", { enumerable: true, get: function () { return ToleranceZones_1.UnusedSideZone; } });
//# sourceMappingURL=index.js.map